export const LOCALES = {
	en: 'en',
	ru: 'ru',
	uk: 'uk',
};

export const LOCALES_INFO = {
	en: { name: LOCALES.en, label: 'english', title: 'English' },
	uk: { name: LOCALES.uk, label: 'украинский', title: 'Ukrainian' },
	ru: { name: LOCALES.ru, label: 'русский', title: 'Russian' },
};
